import styled, { css } from 'styled-components'

interface IWrapperProps {
  actionBackground: boolean
}

export const Wrapper = styled.div<IWrapperProps>`
  text-align: center;
  padding: 24px;
  button {
    ${(props) =>
      props.actionBackground &&
      css`
        background-color: #e7f3fe !important;
      `}
    box-shadow: none;
    border: none;
    border-radius: 8px;
    padding: 0 8px;
    font-weight: 700;
    color: #0085ff !important;
    svg {
      margin-right: 5px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
`

interface IIconWrapperProps {
  iconSize: string
}

export const IconWrapper = styled.div<IIconWrapperProps>`
  ${(props) =>
    props.iconSize == 'normal' &&
    css`
      width: 72px;
      height: 72px;
      svg {
        padding: 10px;
        height: 20px;
      }
    `}
  ${(props) =>
    props.iconSize == 'small' &&
    css`
      width: 56px;
      height: 56px;
      svg {
        padding: 9px;
        height: 15px;
      }
    `}
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin: 0 auto;
  svg {
    background-color: white;
    border-radius: 8px;
    color: #757575;
  }
`

export const Title = styled.div`
  color: #757575;
  padding: 16px 0 4px;
  font-size: 14px;
`
